import { z } from 'zod';

const EventInvolvementRelationshipManagerSchema = z.object({
  type: z.literal('event_involvement'),
  eventId: z.string(),
  entityType: z.string(),
  entityId: z.string(),
});

const OrganizationMembershipRelationshipManagerSchema = z.object({
  type: z.literal('organization_membership'),
  characterId: z.string(),
  organizationId: z.string(),
});

const OrganizationPartOfRelationshipManagerSchema = z.object({
  type: z.literal('organization_part_of'),
  childOrganizationId: z.string(),
  parentOrganizationId: z.string(),
});

/**
 * Relationship schema.
 */
export const RelationshipSchema = z.object({
  id: z.string().describe('Unique identifier for the Relationship.'),
  entityAId: z.string().describe('The ID of the first entity.'),
  entityAType: z.string().describe('The type of the first entity.'),
  entityBId: z.string().describe('The ID of the second entity.'),
  entityBType: z.string().describe('The type of the second entity.'),
  forwardDescription: z.string().describe('A textual description of the relationship from entity A to B.'),
  reverseDescription: z.string().optional().describe('A textual description of the relationship from entity B to A.'),
  connectorStyle: z.enum(['straight', 'orthogonal']).optional().describe('How this relationship is drawn in a graph.'),
  managedBy: z.discriminatedUnion('type', [
    EventInvolvementRelationshipManagerSchema,
    OrganizationMembershipRelationshipManagerSchema,
    OrganizationPartOfRelationshipManagerSchema,
  ]).optional().describe('Metadata for relationships automatically managed by another feature.'),
});

export type Relationship = z.infer<typeof RelationshipSchema>;
